export const TitleMap = {
  specialist: 'Especialista',
  master: 'Mestre',
  doctor: 'Doutor'
};
